module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-2.013b8d99.png";